import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconColumnWideHalfRemove: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconColumnWideHalfRemove"><Path d="M2.5 12V19.5L12.5 19.5M2.5 12V4.5H21.5V12H2.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M16.5 16.5L19 19M19 19L21.5 21.5M19 19L16.5 21.5M19 19L21.5 16.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconColumnWideHalfRemove;
